export default function Hero() {
  const scrollToForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Lighter Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/27fbccf3d696ba8516c59be4982c2569.jpg"
          alt="Luxury kitchen countertop installation"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/40 via-gray-900/30 to-gray-900/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl">
            Custom Countertops Crafted for <span className="text-amber-400">Beauty</span> and <span className="text-amber-400">Durability</span>
          </h1>
          <p className="text-xl md:text-2xl text-white mb-10 max-w-3xl mx-auto drop-shadow-lg">
            Expert fabrication and installation serving Salt Lake County for over 30 years
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button 
              onClick={scrollToForm}
              className="bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-amber-700 transition-all shadow-2xl hover:shadow-amber-600/50 hover:scale-105 whitespace-nowrap w-full sm:w-auto"
            >
              Request Free Estimate
            </button>
            <a 
              href="tel:801-706-1610"
              className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all shadow-2xl hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Call Now</span>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-8 text-white">
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i className="ri-shield-check-line text-2xl text-amber-400"></i>
              <span className="text-sm font-semibold drop-shadow-lg">Licensed & Insured</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i className="ri-award-line text-2xl text-amber-400"></i>
              <span className="text-sm font-semibold drop-shadow-lg">30+ Years Experience</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg">
              <i className="ri-star-fill text-2xl text-amber-400"></i>
              <span className="text-sm font-semibold drop-shadow-lg">5.0 Rating</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white drop-shadow-lg"></i>
      </div>
    </section>
  );
}